import { dispatchRefresh } from "../../actions"
import { TerramapContext } from "../../context"
import { State } from "../../state"

interface Props {
    state: Extract<State, { type: "setParameters" }>
}

export function SetParametersFooter({ state }: Props) {

    const { dispatch, api } = React.useContext(TerramapContext)
    const { parameters, selection } = state

    const cancel = () => dispatch({ "type": "index" })

    const canCommit = parameters.year
        && parameters.date
        && Object.values(parameters.fields).some(b => b)

    const commit = async () => {

        const { fields } = selection

        const set = new Set(
            Object.entries(parameters.fields)
                .filter(e => e[1])
                .map(e => Number(e[0]))
        )

        const layerIds = fields
            .filter(f => set.has(f.field.fieldId))
            .flatMap(f => f.layers)
            .map(l => l.layerId)

        await api.updateParameters(parameters, layerIds)

        dispatchRefresh(dispatch, api, state.selection)

    }

    return <>

        <div className="left">
        </div>

        <div className="actions">
            <button type="button" className="btn btn-warning" onClick={() => cancel()}>
                Cancel
            </button>
            <button type="button" className="btn btn-success" onClick={() => commit()} disabled={!canCommit}>
                Save
            </button>
        </div>

    </>

}
